import router from "../router";
import store from "@/store";
import CryptoJS from "crypto-js";
import { GET_BASECONFIG } from "@/store/types";
import { message } from "ant-design-vue";
export const getAnimationName = (to, form) => {
  const toMeta = to.meta;
  const formMeta = form.meta;
  if (!toMeta || !formMeta) {
    return "fade";
  }
  if (toMeta.transition) {
    return toMeta.transition;
  } else {
    if (!formMeta.transitionOrder || !toMeta.transitionOrder) {
      return "fade";
    } else {
      if (formMeta.transitionOrder > toMeta.transitionOrder) {
        return "fade1";
      } else if (formMeta.transitionOrder == toMeta.transitionOrder) {
        return "fade";
      } else {
        return "fade2";
      }
    }
  }
};

export const toLogin = (url) => {
  const { toLoginUrl } = store.getters["config/" + GET_BASECONFIG];
  if (toLoginUrl) {
    const redirectUrl = url || encodeURIComponent(location.href);
    setTimeout(() => {
      window.open(`${toLoginUrl}?redirectUrl=${redirectUrl}`, "_self");
    }, 200);
  }
};

export const arrayNoRepeat = (arr) => {
  return Array.from(new Set(arr))
}

export const navigateTo = (url, target = "_self", type) => {
  if (!url) return;
  const {
    lessonApiDomain,
    lessonDomain,
    mykehouDomain,
    toLoginUrl,
    orderDomain,
    portalDomain,
  } = store.getters["config/" + GET_BASECONFIG];
  switch (type) {
    case 1:
      if (target == "_blank") {
        const route = router.resolve({ path: url, query: getQuery(url) });
        // console.log(route);
        window.open(route.href, "_blank");
      } else if (target == "_replace") {
        router.replace(url);
      } else {
        router.push(url);
      }
      break;
    case 2:
      // window.open(isCompleteURL(`${lessonApiDomain}${url}`), target);
      window.open(`${lessonApiDomain}${url}`, target);
      break;
    case 3:
      // window.open(isCompleteURL(`${mykehouDomain}${url}`), target);
      window.open(`${mykehouDomain}${url}`, target);
      break;
    case 4:
      const redirectUrl = encodeURIComponent(url);
      window.open(`${toLoginUrl}?redirectUrl=${redirectUrl}`, target);
      break;
    case 5:
      window.open(`${orderDomain}${url}`, target);
      break;
    case 6:
      window.open(`${portalDomain}/view/web/#/${url}`, target);
      break;
    case 7:
      window.open(`${lessonDomain}/view/area/#/${url}`, target);
      break;
    default:
      window.open(url, target);
      // window.open(isCompleteURL(url), target);
      break;
  }
};

export const getQuery = (str) => {
  if (typeof str !== "string" || !str.split("?")[1]) {
    return;
  }
  let queryStr = str.split("?")[1].split("&");
  const obj = queryStr.reduce((acc, cur) => {
    let i = cur.indexOf("=");
    let key = cur.substring(0, i);
    let value = cur.substring(i + 1);
    acc[key] = value;
    return acc;
  }, {});
  return obj;
};
export const parseParams = (uri, params = {}) => {
  const paramsArray = [];
  Object.keys(params).forEach((key) =>
    paramsArray.push(`${key}=${params[key]}`)
  );
  if (uri.search(/\?/) === -1) {
    uri += `?${paramsArray.join("&")}`;
  } else {
    uri += `&${paramsArray.join("&")}`;
  }
  return uri;
};

/**
 * url地址完整性校验
 * @param {String} url 需要校验的地址
 */
export const isCompleteURL = (url) => {
  const bool = /(http|https):\/\/([\w.]+\/?)\S*/.test(url);
  return bool ? url : `http://${url}`;
};

/**
 * 文本复制到剪贴板
 * @param {String} content 待复制的文本
 * @param {String} msg 复制成功后提示文本
 */
export const copyToClipboard = (content, msg = "链接复制成功！") => {
  const input = document.createElement("textarea");
  input.setAttribute("readonly", "readonly");
  input.value = content
  document.body.appendChild(input);
  input.select();
  var isCopyOk = document.execCommand("copy");
  document.body.removeChild(input);
  if (isCopyOk) {
    message.success(msg);
  }
};

export const getFileType = (fileType, isLink) => {
  if (isLink === 'YES' || isLink === 1) {
    return 'attach'
  } else {
    // console.log('fileType', fileType);
    fileType = fileType && fileType.toLowerCase();
    const videos = [
      // 视频
      'mp4', 'wmv', 'asf', 'asx', 'mpg', 'mpeg', 'mpe', 'rm', 'rmvb', '3gp', 'mov', 'm4v', 'avi', 'dat', 'mkv', 'flv', 'vob',
      // 音频
      'mp3', 'wav', 'wma', 'mp2', 'flac', 'midi', 'ra', 'ape', 'aac', 'cda'
    ];
    const imgs = ['jpeg', 'dds', 'psd', 'pdt', 'webp', 'xmp', 'gif', 'bmp', 'svg', 'tiff', 'jpg', 'png']
    const docs = [
      'doc', 'docx', 'pdf', 'pdfx'
    ];
    const downs = ['xlsx', 'xls', 'txt']
    const ppts = ['ppt', 'pptx'];
    if (videos.some((vs) => vs === fileType)) {
      return 'video';
    }
    if (imgs.some((is) => is === fileType)) {
      return 'img';
    }
    if (docs.some((is) => is === fileType)) {
      return 'doc';
    }
    if (ppts.some((is) => is === fileType)) {
      return 'ppt';
    }
    if (downs.some((is) => is === fileType)) {
      return 'down'
    }
    return fileType;
  }
};

export const getUrlType = (url) => {
  const extName = url.split(".").pop();
  return getFileType(extName);
};

export const encryptByDES = (message, key) => {
  let keyHex = CryptoJS.enc.Utf8.parse(key);
  let encrypted = CryptoJS.DES.encrypt(message + "", keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString();
};

export const insertStr = (str, index, insertStr) => {
  return str.slice(0, index) + insertStr + str.slice(index);
};

/**
 * 下载地址
 * @param {String} url
 */
export const downloadFile = (url, fileName = "下载", blob = false) => {
  const link = document.createElement("a");
  link.style.display = "none";
  if (blob) {
    link.href = window.URL.createObjectURL(url);
  } else {
    link.href = url
  }
  link.setAttribute("download", fileName);
  document.body.appendChild(link)
  link.click()
  link.remove()
  //释放内存
  window.URL.revokeObjectURL(link.href)
};
/**
 * 文件导出
 * @param {blob}    data	二进制文件流
 * @param {String}  name	文件名
 */
export const fileExport = (data, name) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  link.remove();
  //释放内存
  window.URL.revokeObjectURL(link.href);
};

export const pow1024 = (num) => {
  return Math.pow(1024, num);
};
/**
 * 文件大小 字节转换单位
 * @param size
 */
export const filterSize = (size) => {
  if (!size) return "";
  if (size < pow1024(1)) return size + " B";
  if (size < pow1024(2)) return (size / pow1024(1)).toFixed(2) + " KB";
  if (size < pow1024(3)) return (size / pow1024(2)).toFixed(2) + " MB";
  if (size < pow1024(4)) return (size / pow1024(3)).toFixed(2) + " GB";
  return (size / pow1024(4)).toFixed(2) + " TB";
};

// 设置系统主题
export const setTheme = (theme) => {
  document.documentElement.setAttribute('data-theme', theme)
}